import { useEffect } from 'react';
import { useGetPipelineSchemaViolationsDetails } from '@ion/api';
import schemaViolationsDetailsColumns from './schemaViolationsDetailsColumns';
import { useEventSchemaViolationsPageContext } from 'app/event-schema-violations/EventSchemaViolationsPage/EventSchemaViolationsPageContextProvider';
import useRowClickedProps from './useRowClickedProps';

const STATIC_PROPS = {
  pagination: true,
  columns: schemaViolationsDetailsColumns,
};

export default function useSchemaViolationsDetailsTable() {
  const { pipeline, eventName, schemaId, earliestSeen } = useEventSchemaViolationsPageContext();
  const [getPipelineSchemaViolationsDetails, { loading, data }] = useGetPipelineSchemaViolationsDetails();
  const rowClickProps = useRowClickedProps();

  useEffect(() => {
    getPipelineSchemaViolationsDetails({
      earliestSeen,
      eventName,
      schemaId,
      clusterId: pipeline.clusterId,
      writekey: pipeline.writekey,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pipeline.clusterId, pipeline.writekey, schemaId, eventName]);

  return {
    ...STATIC_PROPS,
    ...rowClickProps,
    loading,
    data,
  };
}
